var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.1666 16.9833H29.35C25.4 16.9833 22.1833 13.7667 22.1833 9.81668V5.00001C22.1833 4.08334 21.4333 3.33334 20.5166 3.33334H13.45C8.31663 3.33334 4.16663 6.66668 4.16663 12.6167V27.3833C4.16663 33.3333 8.31663 36.6667 13.45 36.6667H26.55C31.6833 36.6667 35.8333 33.3333 35.8333 27.3833V18.65C35.8333 17.7333 35.0833 16.9833 34.1666 16.9833Z",
    fill: "#FA8C16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 3.68334C25.65 3.00001 24.4667 3.46668 24.4667 4.41668V10.2333C24.4667 12.6667 26.5333 14.6833 29.05 14.6833C30.6333 14.7 32.8333 14.7 34.7167 14.7C35.6667 14.7 36.1667 13.5833 35.5 12.9167C33.1 10.5 28.8 6.15001 26.3333 3.68334Z",
    fill: "#FA8C16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument2);
export default __webpack_public_path__ + "static/media/document_2.dfbb55a8f9b34f2d8e7531c65b3a945f.svg";
export { ForwardRef as ReactComponent };